import { FilterEntity } from '_entities';
import removeEmptinessFromFilters from './removeEmptinessFromFilters';

const { applyFilters } = FilterEntity.actions;

// `setCurrentPage` is optional only because several older callers own no page state; every list page
// that does should pass it.
export default ({ search = '', generalFilters, getApi, dispatch, setCurrentPage } = {}) => {
  const filters = { ...generalFilters, search };

  const newFilters = removeEmptinessFromFilters(filters);

  getApi({ page: 1, filters: newFilters });
  dispatch(applyFilters(newFilters));
  // The request, the response and the URL are all page 1 — move the pager with them. Without this the
  // control still highlights whatever page the user searched from, and the next click paginates from
  // there: searching on page 3 then clicking "4" silently skips page 2 of the new results.
  if (setCurrentPage) setCurrentPage(1);
};
